module.exports = __webpack_public_path__ + "img/校本题库.cbe36b93.png";